import MaterialReactTable, { MRT_ColumnDef } from "material-react-table";
import { Ticket, TicketProcess } from "../../../../redux/slices/ticket/ticketModel";
import { useEffect, useMemo } from "react";
import moment from "moment";
import { useGetTicketProcessQuery, useMarkTicketAsReadQuery } from "../../../../redux/slices/ticket/apiTicketSlice";
import { useAppDispatch } from "../../../../redux/hook";
import { setDrawerTicket } from "../../../../redux/slices/ticket/ticketSlice";
import Swal from "sweetalert2";
type Props = {
  className: string,
  ticket: Ticket,
}

const TableTicketProcess: React.FC<Props> = ({ className, ticket }) => {

  const { data: any } = useMarkTicketAsReadQuery(ticket.id)
  const dispatch = useAppDispatch()
  const replyTicket = () => {
    dispatch(setDrawerTicket({
      id: ticket.id,
      reference: ticket.reference
    }))
  }
  const { data: ticketProcesses } = useGetTicketProcessQuery(ticket.id)
  const showMoreDescription = (message: string) => {
    Swal.fire({
      html: message,
      customClass: `w-90 text-start float-start`,
      heightAuto: true
    })
  }
  const processColumns = useMemo<MRT_ColumnDef<TicketProcess>[]>(
    () => [
      {
        accessorKey: 'description',
        header: 'Description',
        enableColumnOrdering: false,
        enableEditing: false,
        enableSorting: false,
        maxSize: 300,
        Cell: ({ row }) => (
          <div className='d-flex align-items-center w-350px' style={{
            whiteSpace: "normal",
            wordWrap: "break-word"
          }}>
            {
              row.original.description.substring(0, 18) == "<div class='mt-2'>" ?
                <span className="ms-1 cursor-pointer" onClick={() => { showMoreDescription(row.original.description) }}>Show additional feature request detail...</span>
                :
                <div className="text-capitalize">
                  {row.original.description.length > 100 ?
                    <span className="ms-1 cursor-pointer" onClick={() => { showMoreDescription("<div class='text-start'>" + row.original.description + "</div>") }}>{row.original.description.substring(0, 90)} [More...]</span>
                    :
                    <span>{row.original.description}</span>
                  }

                </div>

            }

          </div>
        ),
      },
      {
        accessorKey: 'created_by',
        header: 'Submitted by',
        enableColumnOrdering: false,
        enableEditing: false,
        enableSorting: true,
        maxSize: 50,
        Cell: ({ row }) => {
          return (
            <div className='text-start'>
              {
                row.original.created_type == 1 ?
                  <span>{row.original.created_by}</span>
                  :
                  <span>Superbolt</span>
              }
            </div>
          )
        },
      },
      {
        accessorKey: 'created_at',
        header: 'Submitted At',
        enableColumnOrdering: false,
        enableEditing: false,
        enableSorting: true,
        Cell: ({ cell }) => (
          <div className={`d-flex text-muted justify-content-start tooltip-bottom`} >
            {moment(moment.utc(cell.getValue<string>()).toDate()).format("DD-MMM-YYYY  HH:mm:ss A")}
          </div>
        ),
      },
    ],
    [ticket.processes],
  );

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>
            <h1>Ticket reference: <strong>{ticket.reference}</strong></h1>
            {ticket.statusId === 3 && <div className="badge badge-light-success fw-bolder">Closed</div>}
          </h3>
        </div>
        {ticket.statusId !== 3 &&
          <button className="btn btn-success align-self-center"
            data-bs-toggle="offcanvas"
            aria-controls="staticBackdrop"
            data-bs-target="#kt_drawer_reply_ticket"
            id="kt_drawer_reply_ticket_button"
            onClick={() => replyTicket()}
            data-kt-drawer-show="true" >Reply
          </button>
        }
      </div>
      <div className='card-body border-top p-9'>
        <div className='table-responsive'>
          {ticket &&
            <MaterialReactTable
              columns={processColumns}
              data={ticketProcesses ? ticketProcesses : []}
              enableFullScreenToggle={false}
              enableGlobalFilter={false}
              muiTableHeadCellProps={{ sx: { fontWeight: 'bold', textTransform: 'uppercase', fontSize: '1.1rem' }, }}
              initialState={{
                columnVisibility: { category: false },
                density: 'compact',
                showGlobalFilter: false,
              }}
              muiTableBodyCellProps={{
                sx: {
                  fontSize: '1.1rem',
                  backgroundColor: '#fcfcfc55',
                }
              }}
            />
          }
        </div>
      </div>
    </div>
  )
}

export { TableTicketProcess }